import React from "react";
import PropTypes from "prop-types";
import FeatherIcon from 'feather-icons-react';

const CustomerDynamicTable = ({

  data = [],
  columns = [],
  onAdd,
  onEdit,
  onDelete,
  onCancel,
  onLogout,
  onView,
  onScan,
  onSendMsg,
  search = "",
  onSearchChange,
  actions = true,
}) => {
  const hasData = data && data.length > 0;

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="listjs-table">
              <div className="row g-4 mb-3">
                <div className="col-sm-auto">
                  
                    <div className="search-box ms-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={search}
                        onChange={onSearchChange}
                      />
                      <i className="ri-search-line search-icon" />
                    </div>
                </div>
                { onAdd && (
                <div className="col-sm">
                  <div className="d-flex justify-content-sm-end">
                  <button className="btn btn-success" onClick={onAdd}>
                    <i className="ri-add-line align-bottom me-1" /> Add
                  </button>
                 
                  </div>
                </div> 
                )}
              </div>

              <div className="table-responsive table-card mt-3 mb-1">
                <table className="table align-middle table-nowrap">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" style={{ width: 50 }}>
                        <div>
                          #
                        </div>
                      </th>
                      {columns.map((col, idx) => (
                        <th key={idx} className="sort">{col.header}</th>
                      ))}
                      {actions && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {hasData ? (
                      data.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            {Number(idx)+1}
                          </td>
                          {columns.map((col, i) => (
                            <td key={i}>
                              {col.render
                                ? col.render(item[col.accessor], item)
                                : item[col.accessor]}
                            </td>
                          ))}
                          {actions && (
                            <td>
                              <div className="d-flex gap-2">
                                { onScan && item.device_status !== 'connected' && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Scan" className="btn btn-ghost-primary btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onScan(item)}
                                  >
                                    <div>
                                      <i className="ri-qr-code-line" style={{ fontSize: '14px', color: 'blue' }}></i>
                                    </div>
                                  </button>
                                )}
                                {onEdit && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" className="btn btn-ghost-primary btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onEdit(item)}
                                  >
                                    <FeatherIcon icon="edit-3" size="14" color="blue" />
                                  </button>
                                )}
                                {onView && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="View Details" className="btn btn-ghost-warning btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onView(item)}
                                  >
                                    <FeatherIcon icon="eye" size="14" color="orange" />
                                  </button>
                                )}
                                {onDelete && item.device_status !== 'connected'  && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Delete"  className="btn btn-ghost-danger btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onDelete(item)}
                                  >
                                    <FeatherIcon icon="trash-2" size="14" color="red" />
                                  </button>
                                )}
                                {onCancel  && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Cancel"  className="btn btn-ghost-danger btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onCancel(item)}
                                  >
                                    <FeatherIcon icon="x-octagon" size="14" color="red" />
                                  </button>
                                )}
                                {onSendMsg && item.device_status === 'connected'  && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Test Message"  className="btn btn-ghost-success btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onSendMsg(item)}
                                  >
                                    <FeatherIcon icon="message-circle" size="14" color="green" />
                                  </button>
                                )}
                                {onLogout && item.device_status === 'connected'  && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Logout Device"  className="btn btn-ghost-danger btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onLogout(item)}
                                  >
                                    <FeatherIcon icon="power" size="14" color="red" />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={columns.length + (actions ? 2 : 1)}>
                          <div className="text-center text-muted">No data found.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

CustomerDynamicTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
      render: PropTypes.func,
    })
  ).isRequired,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  onLogout : PropTypes.func,
  onSendMsg : PropTypes.func,
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  actions: PropTypes.bool,
};

export default CustomerDynamicTable;